import { disableBodyScroll, clearAllBodyScrollLocks } from "./body-scroll-lock";

const mainNav = document.querySelector(".header-nav-main-list");
const body = document.querySelector("body");

function resetNavItems() {
  if (mainNav) {
    const primaryItems = mainNav.querySelectorAll(".header-nav-main-list-item");

    mainNav.classList.remove("active");
    primaryItems.forEach((item) => {
      const link = item.querySelector("button.header-nav-primary-link");
      link && link.setAttribute("aria-expanded", "false");
    });
  }
}

function toggleScrollLock(isExpanded: boolean) {
  if (body) {
    if (isExpanded) {
      disableBodyScroll(body);
    } else {
      clearAllBodyScrollLocks();
    }
  }
}

if (mainNav) {
  const primaryItems = mainNav.querySelectorAll(".header-nav-main-list-item");
  const currentUrl = window.location.href;

  function handleEvent(isExpanded: boolean, link: Element, isMobile: boolean = false) {
    link.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    mainNav && mainNav.classList.toggle("active", isExpanded);

    if (isMobile) {
      toggleScrollLock(isExpanded);
    }
  }

  primaryItems.forEach((item) => {
    const link = item.querySelector("button.header-nav-primary-link");
    const mobileToggle = item.querySelector(".header-nav-dropdown-dismiss");
    if (!link) return;

    // check if url has a hash, if so, open the nav
    if (currentUrl.includes("#")) {
      const dataLabel = link.getAttribute("data-label");
      if (dataLabel && currentUrl.includes(dataLabel)) {
        handleEvent(true, link);
      }
    }

    let hoverTimer = null as null | number;

    item.addEventListener("mouseenter", function () {

      hoverTimer = setTimeout(() => {
        handleEvent(true, link);
      }, 200);
    });

    item.addEventListener("mouseleave", function () {
      setTimeout(() => {
        handleEvent(false, link);
      }, 200);
      hoverTimer && clearTimeout(hoverTimer);
    });


    // Make the nav work on mobile touch events
    link.addEventListener("touchstart", function () {
      handleEvent(!mainNav.classList.contains("active"), link, true);
    });

    // Close the nav on mobile
    mobileToggle &&
      mobileToggle.addEventListener("click", function () {
        handleEvent(false, link);
      });
    mobileToggle &&
      mobileToggle.addEventListener("touchstart", function () {
        handleEvent(false, link, true);
      });

    // Keyboard navigation
    item.addEventListener("keydown", function (e: Event) {
      // Enter or Space or ArrowDown
      if (
        (e as KeyboardEvent).key === "Enter" ||
        (e as KeyboardEvent).key === " " ||
        (e as KeyboardEvent).key === "ArrowDown"
      ) {
        resetNavItems();
        handleEvent(true, link);
      }
    });

    // if item is the last in the list, close the nav on tab
    if (item === primaryItems[primaryItems.length - 1]) {
      item.addEventListener("keydown", function (e: Event) {
        if ((e as KeyboardEvent).key === "Tab") {
          const target = e.target as Element;
          if (target.classList.contains("banner-link") && target.querySelector(".iconBg-info")) {
            handleEvent(false, link);
          }
        }
      });
    }
  });
}

// Language switcher
const langNav = document.querySelector(".header-tools-languages");

if (langNav) {
  const langButton = langNav.querySelector(".header-tools-languages-button");
  const langList = langNav.querySelectorAll(".header-tools-languages-list");

  if (langButton) {
    langNav.addEventListener("mouseenter", function () {
      langButton.setAttribute("aria-expanded", "true");
      langNav.classList.add("active");
    });

    langNav.addEventListener("mouseleave", function () {
      langButton.setAttribute("aria-expanded", "false");
      langNav.classList.remove("active");
    });

    // mobile touch
    langButton.addEventListener("touchstart", function () {
      langButton.setAttribute(
        "aria-expanded",
        langNav.classList.contains("active") ? "false" : "true"
      );
      langNav.classList.toggle("active");
    });

    // keyboard navigation
    langButton.addEventListener("keydown", function (e: Event) {
      if ((e as KeyboardEvent).key === "Enter" || (e as KeyboardEvent).key === " ") {
        langButton.setAttribute(
          "aria-expanded",
          langNav.classList.contains("active") ? "false" : "true"
        );
        langNav.classList.toggle("active");
      }
    });

    langList.forEach((list) => {
      list.addEventListener("keydown", function (e: Event) {
        if ((e as KeyboardEvent).key === "Tab") {
          const target = e.target as Element;
          // if target's parent is the last child of langList, close the langNav
          if (target.parentElement === list.lastElementChild) {
            langButton.setAttribute("aria-expanded", "false");
            langNav.classList.remove("active");
          }
        }
      });
    });
  }
}

// Footer back to top button
const backToTopBtn = document.querySelector(".footer-topBtn");
if (backToTopBtn) {
  backToTopBtn.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
}
